import { Stack } from '@zoopla-eng/zds/stack';
import { ToggleGroup } from '@zoopla-eng/zds/toggles';
import { itemStyle } from './Modal.styles.css';
import { customStackStyle } from './LettingTypeVariant.styles.css';

type OptionalBoolean = '' | 'true' | 'false';
type TriState = 'only' | 'include' | 'exclude';

export type IsSharedAccommodation = OptionalBoolean;
export type IsRetirementHome = OptionalBoolean;

type LettingTypeVariant = {
    isSharedAccommodation: IsSharedAccommodation;
    isRetirementHome: IsRetirementHome;
};

type LettingTypeVariantProps = {
    value: LettingTypeVariant;
    onChange: (homeTypeToRent: LettingTypeVariant) => void;
};

function mapToToggleGroup(value: OptionalBoolean) {
    const options: {
        [key: string]: TriState;
    } = {
        '': 'include',
        true: 'only',
        false: 'exclude'
    };

    return options[value];
}

function mapToFormValue(value: TriState): OptionalBoolean {
    const options: {
        [key: string]: OptionalBoolean;
    } = {
        include: '',
        only: 'true',
        exclude: 'false'
    };

    return options[value];
}

export const LettingTypeVariant = ({
    value,
    onChange
}: LettingTypeVariantProps) => {
    return (
        <div className={customStackStyle}>
            <Stack
                flexDirection="row"
                flexWrap="wrap"
                // columnGap="0"
                rowGap="S400"
                alignItems="center"
                justifyContent="space-between"
            >
                <div className={itemStyle}>
                    <p>House share</p>
                </div>
                <div className={itemStyle}>
                    <ToggleGroup
                        label="House share"
                        value={mapToToggleGroup(value.isSharedAccommodation)}
                        items={[
                            {
                                id: 'include_shared_accommodation_include',
                                value: 'include',
                                label: 'Include'
                            },
                            {
                                id: 'include_shared_accommodation_exclude',
                                value: 'exclude',
                                label: 'Exclude'
                            },
                            {
                                id: 'include_shared_accommodation_only',
                                value: 'only',
                                label: 'Show only'
                            }
                        ]}
                        onValueChange={(isSharedAccommodationValue) => {
                            onChange({
                                ...value,
                                isSharedAccommodation: mapToFormValue(
                                    isSharedAccommodationValue
                                )
                            });
                        }}
                    />
                </div>
            </Stack>
            <Stack
                flexDirection="row"
                flexWrap="wrap"
                // columnGap="0"
                rowGap="S400"
                alignItems="center"
                justifyContent="space-between"
            >
                <div className={itemStyle}>
                    <p>Retirement homes</p>
                </div>
                <div className={itemStyle}>
                    <ToggleGroup
                        label="Retirement homes"
                        value={mapToToggleGroup(value.isRetirementHome)}
                        items={[
                            {
                                id: 'retirement_homes_include',
                                value: 'include',
                                label: 'Include'
                            },
                            {
                                id: 'retirement_homes_exclude',
                                value: 'exclude',
                                label: 'Exclude'
                            },
                            {
                                id: 'retirement_homes_only',
                                value: 'only',
                                label: 'Show only'
                            }
                        ]}
                        onValueChange={(isRetirementHomeValue) => {
                            onChange({
                                ...value,
                                isRetirementHome: mapToFormValue(
                                    isRetirementHomeValue
                                )
                            });
                        }}
                    />
                </div>
            </Stack>
        </div>
    );
};
